import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { AlarmsService } from 'src/app/services/alarms/alarms.service';
import { HeaderCommunicationService } from 'src/app/services/node/header-communication.service';
import { CabinetService } from 'src/app/services/office/cabinet.service';
import { StringUtilsService } from 'src/app/services/string-utils/string-utils.service';
import { Destinataire } from 'src/app/utils/interfaces/new/destinataire.interface';
import { Filtres } from 'src/app/utils/interfaces/new/filtres.interface';
import { Header } from 'src/app/utils/interfaces/new/header.interface';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';

@Component({
  selector: 'app-alarms',
  templateUrl: './alarms.component.html',
  styleUrls: ['./alarms.component.scss']
})
export class AlarmsComponent implements OnInit {

  public alarmColumnTable = [];
  public alarmList: Paginated<any>;
  public profilsCabinet: Destinataire[];
  public formDate: FormGroup;
  public startDate: string = moment(Date()).format('YYYY-MM-DD');
  public endDate: string = moment(Date()).format('YYYY-MM-DD');
  public filterDay: any = 0;
  public filtre: Filtres = {
    perpage: 8,
    currentPage: 1
  };

  constructor(
    private alarmService: AlarmsService,
    private _cabinet: CabinetService,
    private _send: HeaderCommunicationService,
    private _strUtilsSrv: StringUtilsService
  ) {
    const head: Header = {
      isBack: true,
      title: "Alarmes",
      backPage: "home"
    };
    this._send.announceHeader(head);
  }

  async ngOnInit(): Promise<void> {
    this.profilsCabinet = await this._cabinet.findCurrentCabinetDestinataire();
    this.formDate = new FormGroup({
      start: new FormControl(),
      end: new FormControl()
    });

    this.alarmColumnTable = [
      { title: 'Date', data: 'date' },
      { title: 'Patient', data: 'patientName' },
      { title: 'Source', data: 'source' },
      { title: 'Destinataire', data: 'destinataires' },
      { title: 'Alerte', data: 'alerte' }
    ];
    this.getAlarmes();
  }

  public async getAlarmes(): Promise<void> {
    const alarmes = await this.alarmService.find(this.filtre, { start_date: this.startDate, end_date: this.endDate });
    this.alarmList = {
      objects: [],
      page: 1,
      perpage: 8,
      total: alarmes.objects.length
    }

    for (let alarme of alarmes.objects) {
      const source = this.profilsCabinet.find(x => x.id === alarme.source);
      const destinataire = this.profilsCabinet.filter(profil => alarme.destinataires.some(desti => profil.id === desti.idProfil));
      try {
        this.alarmList.objects.push({
          alerte: alarme.alarme,
          date: alarme.date,
          patientName: `${alarme.patientName.split(" ", 2).join(' ')}`, //ici on n'affiche plus dateFin car elle est parfois non définie (si pas de récurrence)
          source: `${source.nom.toLocaleUpperCase()} ${this._strUtilsSrv.uppercaseFirstCharString(source.prenom)}`,
          destinataires: destinataire ? destinataire.map((desti) => ` ${desti.nom.toLocaleUpperCase()} ${this._strUtilsSrv.uppercaseFirstCharString(desti.prenom)}`) : '',
        });
      } catch (e) {
        throw e;
      }
    }
  }

  public async daysFilter(days?: number): Promise<void> {
    this.formDate.reset();

    if (days) {
      const date = new Date();
      date.setDate(date.getDate() + days);
      this.startDate = moment(Date()).format('YYYY-MM-DD');
      this.endDate = moment(date).format('YYYY-MM-DD');
    } else {
      this.startDate = moment(Date()).format('YYYY-MM-DD');
      this.endDate = moment(Date()).format('YYYY-MM-DD');
    }
    this.getAlarmes();
  }

  public selectedDate() {
    this.filterDay = '';
    this.startDate = moment(this.formDate.get('start').value).format('YYYY-MM-DD');
    this.endDate = moment(this.formDate.get('end').value).format('YYYY-MM-DD');
    if (this.formDate.valid) {
      this.getAlarmes();
    }
  }

  public async onSort(event: any): Promise<void> {
    this.filtre.currentPage = 1;
    this.filtre.sortOrder = event.sortOrder;
    this.filtre.sortBy = event.sortBy;
    this.getAlarmes();
  }

  public async onChangePage(value: any): Promise<void> {
    this.filtre.currentPage = value;
    this.getAlarmes();
  }
}
